import React from 'react'
import SubHeader from '../general/SubHeader'

const PrivacyPolicy = () => {
  return (
    <>
    <SubHeader message='Privacy Policy' />

    <section className='my-5'>
      <div className='container'>

Effective Date: 15 January 2026
<br />
At Trade Intell, we are committed to protecting your privacy and complying with applicable global data protection laws, including the General Data Protection Regulation (GDPR) and other international privacy frameworks. This Privacy Policy explains how we collect, use, store, and protect your information.

<br />
<hr />
<br />
<p className='fw-semibold'>1. Information We Collect</p>
We collect only the information necessary to provide and improve our services: -<br />
•	Personal Information: Name, email address, account credentials, and contact details.<br />
•	Trading & Journal Data: Trade entries and exits, journal notes, performance metrics, and analytics created by you.<br />
•	Usage & Technical Data: Device information, IP address, log files, and platform interaction data.<br />
•	Communication Data: Messages shared via live chat, community discussions, and customer support.
<br />
<hr />
<br />

<p className='fw-semibold'>2. Legal Basis for Processing (GDPR)</p>
We process your data under the following lawful bases: -<br />
•	Consent: When you create an account or opt into specific features.<br />
•	Contractual Necessity: To provide core platform services.<br />
•	Legitimate Interest: To improve functionality, ensure security, and prevent misuse.<br />
•	Legal Obligation: To comply with applicable laws and regulations.


<br />
<hr />
<br />

<p className='fw-semibold'>3. How We Use Your Information</p>
Your data is used to: -
•	Deliver platform features such as trade journaling, dashboards, education, and market insights.<br />
•	Provide personalized analytics and performance tracking.<br />
•	Enable community features, including live chat and idea exchange.<br />
•	Maintain platform security, integrity, and fraud prevention.<br />
•	Improve services through aggregated and anonymized analysis.
<br />
<hr />
<br />



<p className='fw-semibold'>4. Data Security</p>
We use industry-standard technical and organizational measures to protect your data, including: -<br />
•	Encryption during data transmission and storage.<br />
•	Secure access controls and authentication.<br />
•	Regular security monitoring and system updates.
<br />
<hr />
<br />

<p className='fw-semibold'>5. International Data Transfers</p>
Your data may be processed or stored in locations outside your country of residence. When such transfers occur, we ensure appropriate safeguards are in place, including standard contractual clauses or equivalent protections, to comply with international data transfer regulations.
<br />
<hr />
<br />

<p className='fw-semibold'>6. Data Sharing</p>
We do not sell your personal data. Data may be shared only: -<br />
•	With trusted service providers under strict confidentiality agreements.<br />
•	When required by law, regulation, or legal proceedings.<br />
•	To protect the rights, safety, or integrity of users and the platform.
<br />
<hr />
<br />


<p className='fw-semibold'>7. Community Features & Public Content</p>
Any information you voluntarily share in public or community areas may be visible to other users. Please exercise caution when sharing personal or financial details.
<br />
<hr />
<br />

<p className='fw-semibold'>8. Data Retention</p>
We retain personal data only for as long as necessary to fulfill service purposes, comply with legal obligations, or resolve disputes. You may request deletion of your data at any time, subject to legal requirements.
<br />
<hr />
<br />

<p className='fw-semibold'>9. Your Rights</p>
Depending on your location, you may have the right to:
•	Access, correct, or delete your personal data.
•	Restrict or object to data processing.
•	Request data portability.
•	Withdraw consent at any time without affecting prior processing.
•	Lodge a complaint with a data protection authority.
<br />
<hr />
<br />

<p className='fw-semibold'>10. Cookies & Tracking Technologies</p>
We use cookies and similar technologies to improve functionality, analyze usage, and personalize content. You may manage or disable cookies through your browser or device settings.
<br />
<hr />
<br />

<p className='fw-semibold'>11. Updates to This Policy</p>
We may update this Privacy Policy periodically. Any material changes will be communicated through the platform or website.
<br />
<hr />
<br />

<p className='fw-semibold'>12. Contact Information</p>
For privacy-related inquiries or data requests, please contact us via the support section of the Trade Intell platform.



      </div>
    </section>
    </>
  )
}

export default PrivacyPolicy